import React, { useState } from 'react';
import { useLocation } from 'react-router';
import {
    Typography,
    DialogContent,
    FormControl,
    RadioGroup,
    SvgIcon,
    Radio,
    Divider,
} from '@mui/material';

// Asset import
import { ReactComponent as FilterAltOutlined } from '~/assets/icons/filter_alt_outlined.svg';
import { ReactComponent as FilterAlt } from '~/assets/icons/filter_alt.svg';

// Util import
import { channelFilter } from '~/util/ordersPanelArrays';

import * as Style from '../styles';

function OrdersFilter({
    ordersFilter,
    setOrdersFilter,
    profile,
}) {
    const [ordersFilterDialogIsOpen, setOrdersFilterDialogIsOpen] = useState(
        false
    );

    const location = useLocation().pathname;
    const showSellerCodes =
        profile?.marcaFilial === 1 &&
        (location === '/cotaPiloto' || location.includes('vendedoraPiloto'));

    const filterLabel = ordersFilter === 'allOrders' ? 'Filtrar' : ordersFilter;

    const handleClickOnRadioButton = event => {
        const chosenFilter = event.target.value;
        setOrdersFilter(chosenFilter);
        setOrdersFilterDialogIsOpen(false);
    };

    return (
        <>
            <Style.DialogContainer
                onClose={() => setOrdersFilterDialogIsOpen(false)}
                open={ordersFilterDialogIsOpen}
            >
                <Style.BrandFilterTitleContainer container>
                    <SvgIcon
                        style={{
                            fill: '#DCC6B7',
                            verticalAlign: 'text-bottom',
                        }}
                        component={FilterAltOutlined}
                    />
                    <Typography
                        display="inline"
                        sx={{ flex: 1, textAlign: 'center' }}
                    >
                        Exibir somente:
                    </Typography>
                </Style.BrandFilterTitleContainer>
                <DialogContent>
                    <FormControl component="fieldset" fullWidth>
                        <RadioGroup
                            value={ordersFilter}
                            onChange={e => handleClickOnRadioButton(e)}
                        >
                            {channelFilter
                                .filter(channel => {
                                    if (
                                        profile?.marcaFilial !== 1 &&
                                        channel.value === 'Joias'
                                    ) {
                                        return false;
                                    }
                                    if (
                                        !showSellerCodes &&
                                        [
                                            'Código atual',
                                            'Código anterior',
                                        ].includes(channel.value)
                                    ) {
                                        return false;
                                    }
                                    return true;
                                })
                                .map(channel => (
                                    <React.Fragment key={channel.value}>
                                        {channel.value === 'Código atual' && (
                                            <Divider
                                                sx={{
                                                    borderColor: '#DCC6B7',
                                                    mt: 1,
                                                    mb: 2,
                                                }}
                                            />
                                        )}
                                        <Style.BrandsFormControlLabel
                                            value={channel.value}
                                            control={
                                                <Radio
                                                    sx={{
                                                        color: '#DCC6B7',
                                                        '&.Mui-checked': {
                                                            color: '#DCC6B7',
                                                        },
                                                    }}
                                                />
                                            }
                                            label={channel.label}
                                        />
                                    </React.Fragment>
                                ))}
                        </RadioGroup>
                    </FormControl>
                </DialogContent>
            </Style.DialogContainer>
            <Style.BrandFilterTextContainer
                item
                container
                primary
                onClick={() => {
                    setOrdersFilterDialogIsOpen(true);
                }}
            >
                <SvgIcon
                    style={{
                        fill: '#DCC6B7',
                        verticalAlign: 'text-bottom',
                    }}
                    component={
                        ordersFilter === 'allOrders'
                            ? FilterAltOutlined
                            : FilterAlt
                    }
                />
                <Style.BrandFilterTextType>
                    {filterLabel}
                </Style.BrandFilterTextType>
            </Style.BrandFilterTextContainer>
        </>
    );
}

export default OrdersFilter;
